import CUSTOM_SVG from './CustomConnectionSVG';
import XERO from './xero-icon.png';

export default {
    CUSTOM_SVG,
    XERO
};
